import { UIView } from "@uirouter/react";

export const CompanyResearchRoot = () => {
    return (
        <div className="sw-layout-module sw-layout-no-scroll-container fadeIn">
            {/*Here the inner page will be render*/}
            <UIView />
        </div>
    );
};
